/* Roundway homepage 2026: reveal-on-scroll and quick add for the rwh-* sections. */
(function () {
  if (window.__rwhHome) return;
  window.__rwhHome = true;

  function reveal(root) {
    var items = (root || document).querySelectorAll('.rwh [data-rwh-reveal]:not(.is-in)');
    if (!('IntersectionObserver' in window)) {
      items.forEach(function (el) { el.classList.add('is-in'); });
      return;
    }
    var fired = false;
    var io = new IntersectionObserver(function (entries) {
      fired = true;
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); }
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.12 });
    items.forEach(function (el) { io.observe(el); });
    // Safety net: if the observer never reports (blocked script, odd browser), show everything rather than leave blank sections.
    setTimeout(function () { if (!fired) items.forEach(function (el) { el.classList.add('is-in'); }); }, 2500);
  }

  function openCart() {
    try {
      if (window.Rebuy && window.Rebuy.SmartCart && typeof window.Rebuy.SmartCart.show === 'function') { window.Rebuy.SmartCart.show(); return true; }
    } catch (e) {}
    document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
    return false;
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('[data-rwh-add]');
    if (!btn) return;
    e.preventDefault();
    var id = btn.getAttribute('data-rwh-add');
    var label = btn.querySelector('span');
    var original = label ? label.textContent : '';
    btn.setAttribute('aria-busy', 'true');
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(id), quantity: 1 }] })
    }).then(function (r) {
      if (!r.ok) throw new Error('add failed');
      btn.classList.add('is-done');
      if (label) label.textContent = 'Added';
      if (!openCart()) setTimeout(function () { window.location.href = '/cart'; }, 400);
      setTimeout(function () { btn.classList.remove('is-done'); if (label) label.textContent = original; }, 2400);
    }).catch(function () {
      window.location.href = btn.getAttribute('data-rwh-url') || '/cart';
    }).finally(function () { btn.removeAttribute('aria-busy'); });
  });

  // Photo bands: zoom out and drift with scroll position, in one rAF loop (transforms only).
  function parallax() {
    var els = [].slice.call(document.querySelectorAll('[data-rwh-parallax]'));
    if (!els.length || (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches)) return;
    var queued = false;
    function frame() {
      queued = false;
      var vh = window.innerHeight;
      els.forEach(function (el) {
        var r = el.parentNode.getBoundingClientRect();
        if (r.bottom < 0 || r.top > vh) return;
        var p = Math.min(1, Math.max(0, (vh - r.top) / (vh + r.height)));
        el.style.transform = 'translate3d(0,' + ((p - 0.5) * -6).toFixed(2) + '%,0) scale(' + (1.2 - p * 0.16).toFixed(3) + ')';
      });
    }
    function queue() { if (!queued) { queued = true; requestAnimationFrame(frame); } }
    // Capture phase so a theme that scrolls an inner wrapper rather than the window still drives it.
    document.addEventListener('scroll', queue, { passive: true, capture: true });
    window.addEventListener('resize', queue);
    queue();
  }

  function init() { reveal(); parallax(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('shopify:section:load', function (e) { reveal(e.target); });
})();
